export enum actionTypes {
    MY_ACCOUNT_SIDEBAR_OPEN = 'MY_ACCOUNT_SIDEBAR:OPEN',
    MY_ACCOUNT_SIDEBAR_CLOSE = 'MY_ACCOUNT_SIDEBAR:CLOSE',
    MY_ACCOUNT_SIDEBAR_TOGGLE = 'MY_ACCOUNT_SIDEBAR:TOGGLE',
    MY_ACCOUNT_SIDEBAR_DATA_UPDATE = 'MY_ACCOUNT_SIDEBAR:DATA:UPDATE',
    MY_ACCOUNT_SIDEBAR_NAME_CHANGE = 'MY_ACCOUNT_SIDEBAR:NAME:CHANGE',
    MY_ACCOUNT_SIDEBAR_HOME_PAGE_SHOW = 'MY_ACCOUNT_SIDEBAR:HOME_PAGE:SHOW',
    MY_ACCOUNT_SIDEBAR_MENU_HEIGHT_CHANGE = 'MY_ACCOUNT_SIDEBAR:HEIGHT:CHANGE',
    MY_ACCOUNT_SIDEBAR_PORTAL_PAGE_SHOW = 'MY_ACCOUNT_SIDEBAR:PORTAL_PAGE:SHOW',
    MY_ACCOUNT_SIDEBAR_MENU_ITEMS_MAIN_MENU_SHOW = 'MY_ACCOUNT_SIDEBAR:MAIN_MENU:SHOW',
    MY_ACCOUNT_SIDEBAR_MENU_ITEMS_SUB_MENU_SHOW = 'MY_ACCOUNT_SIDEBAR:SUB_MENU:SHOW'
}
